import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {Table, Card, Dropdown, Loader} from 'semantic-ui-react';
import {pageSizes} from '../../../common/constants/lists';
import TablePaginator from '../../../common/components/tablePaginator';
import './backOrdersList.scss';

class BackOrdersTable extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  componentDidMount() {
    this.props.clearBackOrdersList();
    this.props.changeBackOrdersListPage(0);
    this.props.changeBackOrdersListPageSize(pageSizes[0].value);
  }

  onPageClick(value) {
    this.props.changeBackOrdersListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeBackOrdersListPageSize(data.value);
  }

  renderBackOrders() {
    const {backOrders} = this.props;

    if (!backOrders.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }

    return backOrders.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.box}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.invoiceQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.invoiceBackOrders}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.nationalBackOrders}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.requesters[0]}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.requesters[1] ? element.requesters[1] : ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.requesters[2] ? element.requesters[2] : ''}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderLoaderOrBackOrders() {
    const {loadingBackOrders} = this.props;

    if (loadingBackOrders) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderBackOrders();
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems, loadingBackOrders} = this.props;

    if (totalItems <= pageSize || loadingBackOrders) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderBackOrdersHeaders() {
    return (
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Caja</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Item</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Cantidad F.</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>B.O. Factura</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              B.O. Nacional
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Agencia 1</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Agencia 2</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Agencia 3</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>{this.renderLoaderOrBackOrders()}</Table.Body>

        {this.renderPagination()}
      </Table>
    );
  }

  render() {
    return (
      <Card fluid raised>
        {this.renderBackOrdersHeaders()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingBackOrders': state.backOrders.loadingBackOrders,
    'backOrders': state.backOrders.page,
    'pageNumber': state.backOrders.pageNumber,
    'pageSize': state.backOrders.pageSize,
    'totalItems': state.backOrders.filteredList.length,
  };
};

const {
  changeBackOrdersListPage,
  changeBackOrdersListPageSize,
  clearBackOrdersList,
  clearTextFilter,
} = Actions;

export default connect(mapStateToProps, {
  changeBackOrdersListPage,
  changeBackOrdersListPageSize,
  clearBackOrdersList,
  clearTextFilter,
})(BackOrdersTable);
